<template>
    <div class="container">
        <div class="form-top">
            <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                    <div style="display:flex;align-items:center;">
                        <div style="margin-right: 60px;">目标列表</div>
                        <el-input style="width:200px;" placeholder="查找目标" v-model="searchForm.name"
                            class="input-with-select" @change="pageChange(1)" clearable>
                            <i class="el-icon-search el-input__icon" slot="suffix"></i>
                        </el-input>
                    </div>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleEditFormShow('')">新增目标
                    </el-button>
                </el-col>
            </el-row>
        </div>
        <div class="form-container">
            <el-table :data="targetList" style="width: 100%" size="medium" :header-cell-style="{height: '50px'}"
                :row-style="{height: '50px',padding: '5px 0'}">
                <el-table-column label="目标" prop="name" min-width="200" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="正在告警" prop="alarm_waiting_handle_count" width="100"></el-table-column>
                <el-table-column label="消警次数" prop="alarm_handled_count" width="100"></el-table-column>
                <el-table-column label="累计告警" prop="alarm_total_count" width="100"></el-table-column>
                <el-table-column label="最近告警时间" min-width="200">
                    <template slot-scope="scope">
                        {{scope.row.last_alarm_time | timeFilter}}
                    </template>
                </el-table-column>
                <el-table-column label="活跃时间" min-width="200">
                    <template slot-scope="scope">
                        {{scope.row.last_active_time | timeFilter}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220" fixed='right'>
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button class="operate-btn" icon="el-icon-s-operation" @click="routerChange(1, scope.row)">详情
                            </el-button>
                            <el-button class="operate-btn" icon="el-icon-edit" @click="handleEditFormShow(scope.row)">编辑</el-button>
                            <el-button class="operate-btn" icon="el-icon-delete" @click="handleDelete(scope.row.id)">删除</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination background layout="prev, pager, next" :page-size="10" :total="total"
                    @current-change="pageChange" :current-page="currentPage"></el-pagination>
            </div>
        </div>
        <el-dialog title="编辑目标" :visible.sync="editFormVisible" width="30%" @closed="handleEditFormClosed">
            <div class="event-dialog-content">
                <el-form :model="editForm">
                    <el-form-item label="目标名称" label-width="80px">
                        <el-input v-model="editForm.name" placeholder="请填写目标名称" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editFormVisible = false">取 消</el-button>
                <el-button style="margin-left: 20px;" type="primary" @click="handleSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Core from '../../core';

export default {
    data() {
        return {
            searchForm: {
                date: ''
            },
            radioGroupList: [
                { label: '1小时', value: '1' },
                { label: '4小时', value: '2' },
                { label: '12小时', value: '3' },
                { label: '1天', value: '4' },
                { label: '3天', value: '5' },
                { label: '7天', value: '6' }
            ],
            editFormVisible: false,
            editForm: {
                id: '',
                name: ''
            },
            targetList: [],
            total: 0,
            currentPage: 1,
            
        };
    },
    watch: {},
    computed: {},
    mounted() {
        this.getTargetList()
    },
    methods: {
        handleEditFormShow(item) {
            if (item) {
                this.editForm.id = item.id
                this.editForm.name = item.name
            }
            this.editFormVisible = true;
        },
        handleEditFormClose() {
            this.editFormVisible = false;
        },
        handleEditFormClosed() {
            Core.Util.emptyObject(this.editForm);
        },
        handleSave() {
            Core.Api.Project.save(this.editForm.id, this.editForm.name).then(() => {
                this.pageChange(1)
                this.handleEditFormClose();
            });
        },
        handleDelete(id) {
            this.$confirm('确定删除该目标？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                Core.Api.Project.delete(id).then((res) => {
                    this.pageChange(1)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
            });
        },
        getTargetList() {
            Core.Api.Project.list(this.currentPage, this.searchForm.name).then((res) => {
                this.total = res.count
                this.targetList = res.project_list
            });
        },
        pageChange(page) {
            this.currentPage = page;
            this.getTargetList()
        },
        routerChange(val, item) {
            switch (val) {
                case 1:
                    {
                        this.$router.push({
                            path: 'detail',
                            query: { project_id: item.id }
                        });
                    }
                    break;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    background: #f1f4f9;
    padding: 0 40px;
    @import '@/common/styles/form.scss';
}
</style>